export default {
  JSONBreadcrumb: (list, siteURL) => {
    const array = [];
    if (list) {
      list.forEach((item, i) => {
        array.push({
          '@type': 'ListItem',
          position: i + 1,
          name: item.name,
        });
        if (item.slug) {
          array[array.length - 1].item = `${siteURL}${item.slug}`;
        }
      });
    }

    return array;
  },

  /*
  * Required for all pages
  * All info is static
  */
  Organization: {
    '@type': 'Organization',
    '@id': 'https://365datascience.com/#organization',
    name: '365 Data Science',
    url: 'https://365datascience.com/',
    sameAs: [
      'https://www.facebook.com/365DataScience/',
      'https://www.linkedin.com/company/365datascience/',
      'https://www.youtube.com/365datascience/',
      'https://twitter.com/365datascience',
    ],
    logo: {
      '@type': 'ImageObject',
      '@id': 'https://365datascience.com/#logo',
      inLanguage: 'en-US',
      url: 'https://365datascience.com/resources/365_datascience_logo_transparent.png',
      width: 1914,
      height: 300,
      caption: '365 Data Science',
    },
    image: {
      '@id': 'https://365datascience.com/#logo',
    },
    members: [],
  },

  /*
  * Required for all pages
  * All info is static
  */
  WebSite: {
    '@type': 'WebSite',
    '@id': 'https://365datascience.com/#website',
    url: 'https://365datascience.com/',
    name: '365 Data Science',
    description: '365datascience.com is an educational career website, designed for aspiring marketing analysts, BI analysts, data analysts and data scientists.',
    publisher: {
      '@id': 'https://365datascience.com/#organization',
    },
    inLanguage: 'en-US',
    potentialAction: [],
  },

  /*
  * Required for all pages
  * Required fields:
  * datePublished
  * dateModified
  *
  * Optional fields:
  * name             - if not importing to home page
  * description      - if not importing to home page
  * potentialAction  - if any
  */
  WebPage: {
    '@type': 'WebPage',
    '@id': 'https://365datascience.com/#webpage',
    url: 'https://365datascience.com/',
    name: 'Learn Data Science with our Training Programs – 365 Data Science',
    isPartOf: {
      '@id': 'https://365datascience.com/#website',
    },
    about: {
      '@id': 'https://365datascience.com/#organization',
    },
    datePublished: '',
    dateModified: '',
    description: 'Build your career in data science! 365 Data Science online training will help you land your dream job. Learn data science and get the skills you need. Try for free!',
    inLanguage: 'en-US',
    potentialAction: [],
  },

  /*
  * Required where there is main image in page
  * Required fields:
  * @id - Link to current page and #primaryimage at the end. Example: 'https://365datascience.com/welcome-to-our-new-blog/#primaryimage'
  * url - Link to main image of the page
  * width - Width of the image linked in url param
  * height - Height of the image linked in url param
  * caption - Usually title / meta title of the page, if image alt not provided
  */
  ImageObject: {
    '@type': 'ImageObject',
    '@id': '',
    inLanguage: 'en-US',
    url: '',
    width: 0,
    height: 0,
    caption: '',
  },

  /*
  * Required for pages like Blog post preview
  * Required fields:
  * headline         - Usually title / meta title of the page
  * image            - contain '@id' with link to main ImageObject
  * datePublished    -
  * dateModified    -
  *
  * Optional fields:
  * keywords         - meta keywords
  * commentCount     - total count of comments, if any / will be used when release comments /
  * potentialAction  - will be used when release comments
  */
  Article: {
    '@type': 'Article',
    '@id': 'https://365datascience.com/data-visualization-project-ideas/#article',
    isPartOf: 'https://365datascience.com/data-visualization-project-ideas/#webpage',
    author: {
      '@id': 'https://365datascience.com/#/schema/person/95d72674591daddb621215fdcf61b144',
    },
    headline: '',
    datePublished: '',
    dateModified: '',
    mainEntityOfPage: 'https://365datascience.com/data-visualization-project-ideas/#webpage',
    commentCount: 0,
    publisher: {
      '@id': 'https://365datascience.com/#organization',
    },
    image: {
      '@id': '',
    },
    video: [],
    keywords: '',
    inLanguage: 'en-US',
    potentialAction: [],
    // potentialAction: [
    //   {
    //     '@type': 'CommentAction',
    //     name: 'Comment',
    //     target: [
    //       'https://365datascience.com/data-visualization-project-ideas/#respond',
    //     ],
    //   },
    // ],
  },

  /*
  * Required where Article object presented
  * All info is static
  */
  Person: {
    '@type': 'Person',
    '@id': 'https://365datascience.com/#/schema/person/95d72674591daddb621215fdcf61b144',
    name: '365 Team',
    url: '',
    image: {
      '@type': 'ImageObject',
      '@id': 'https://365datascience.com/#personlogo',
      inLanguage: 'en-US',
      url: 'https://secure.gravatar.com/avatar/c8ae6a4c7d76739e43025b7fa8cc2060?s=96&d=mm&r=g',
      caption: '365 Team',
    },
  },

  PotentialActions: {
    comment: {
      '@type': 'CommentAction',
      name: 'Comment',
      target: [], // Target must be the link for reply/comment form, e.g. https://365datascience.com/data-visualization-project-ideas/#respond
    },
    consume: {
      '@type': 'ConsumeAction',
      read: {
        '@type': 'ReadAction',
        target: [], // Target must be the link of page where action is, e.g. current page
      },
    },
    search: {
      '@type': 'SearchAction',
      target: '', // Target must be search url with search param {search_term_string}, e.g. https://365datascience.com/?s={search_term_string}
      'query-input': 'required name=search_term_string',
      query: '',
    },
  },

  /*
  * Course preview page
  */
  Course: {
    '@context': 'https://schema.org',
    '@type': 'Course',
    name: '',
    description: '',
    provider: {
      '@type': 'Organization',
      name: '365 Data Science',
      sameAs: 'https://365datascience.com/',
    },
    hasCourseInstance: [{
      '@type': 'CourseInstance',
      instructor: {
        '@type': 'Person',
        name: '365 Team',
      },
      courseMode: 'online',
      accessMode: 'visual',
      courseWorkload: '',
      educationalCredentialAwarded: '',
      url: '',
    }],
    offers: [{
      '@type': 'Offer',
      category: 'Paid',
      priceCurrency: 'USD',
      price: 0,
    }],
  },

  /*
  * Course list page main object
  */
  List: {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [],
  },

  /*
  * Course list page @itemListElement
  */
  ListItem: {
    '@type': 'ListItem',
    position: 0,
    url: '',
  },

  FaqPage: {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [],
  },

  QAPage: {
    '@context': 'https://schema.org',
    '@type': 'QAPage',
    mainEntity: {
      '@type': 'Question',
      name: '',
      text: '',
      answerCount: 0,
      upvoteCount: 0,
      dateCreated: '',
      author: {
        '@type': 'Person',
        name: '', // Published by { user name }
      },
      suggestedAnswer: [],
    },
  },

  Answer: {
    '@type': 'Answer',
    text: '',
    dateCreated: '',
    upvoteCount: 0,
    url: '',
    author: {
      '@type': 'Person',
      name: '', // Published by { user name }
    },
  },

  CollectionPage: {
    '@context': 'http://schema.org',
    '@type': 'CollectionPage',
    '@id': 'https://365datascience.com/#CollectionPage',
    mainEntity: {
      '@type': 'ItemList',
      itemListElement: [],
    },
  },

  VideoObject: {
    '@context': 'https://schema.org',
    '@type': 'VideoObject',
    embedUrl: '',
    contentURL: '',
    name: '',
    description: '',
    duration: '',
    thumbnailUrl: '',
  },

  ItemList: {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [],
  },
};
